import React, { Component } from 'react';
import { Router } from 'react-router-dom';
import { createHashHistory } from 'history';
import withGA from 'components/withGA';

/**
 * The public API for a <Router> that uses window.location.hash.
 * Also logs location changes via Google Analytics.
 */
class HashRouter extends Component {
  constructor (props) {
    super(props);

    this.history = createHashHistory(props);
    this.history.listen(location => {
      this.props.gtag.pageview(location.pathname);
    });
  }

  render () {
    return <Router
      history={this.history}
      children={this.props.children} />;
  }
}

export default withGA(HashRouter);



// WEBPACK FOOTER //
// ./src/components/Router/index.js